import { render } from "./SandboxAquacredCredentials.vue?vue&type=template&id=5ebdf853&scoped=true"
import script from "./SandboxAquacredCredentials.vue?vue&type=script&lang=js"
export * from "./SandboxAquacredCredentials.vue?vue&type=script&lang=js"

import "./SandboxAquacredCredentials.vue?vue&type=style&index=0&id=5ebdf853&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebdf853"]])

export default __exports__